export interface CommunApiPlatformModel<ElementModel> {
	'hydra:member': ElementModel,
	'hydra:totalItems': number,
}

export const INITIAL_COMMUN_API = <ElementModel>(element: ElementModel): CommunApiPlatformModel<ElementModel> => ({
	'hydra:member': element,
	'hydra:totalItems': 0
})